<script lang="ts" setup>
import ProductNoImage from '@/assets/images/ProductNoImage.png'

const props = defineProps({
  isSelected: {
    type: Boolean,
    required: false,
    default: false,
  },
  currency: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  composition: {
    type: String,
    required: true,
  },
  price: {
    type: Number,
    required: true,
  },
})

const productImage = computed(() => props.image || ProductNoImage)

const emits = defineEmits(['clickImage'])
</script>

<template>
  <div class="product" :class="{ 'product--selected': isSelected }">
    <div
      class="product__image"
      :style="{ 'background-image': `url(${productImage})` }"
      @click="emits('clickImage')"
    />

    <div v-if="name" class="product__name">{{ name }}</div>

    <div class="product__footer">
      <the-tooltip
        v-if="composition"
        class="product__composition"
        position-x="center"
        position-y="top"
      >
        <template #activator>
          <div class="product__composition-name">Состав</div>
        </template>

        <span class="product__composition-text">
          {{ composition }}
        </span>
      </the-tooltip>

      <div v-if="price !== undefined" class="product__price">
        <span>{{ `${price} ` }}</span>
        <span>{{ currency }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$product-width: 95px;

.product {
  display: flex;
  flex-direction: column;
  width: $product-width;
  margin-bottom: 25px;
  margin-left: 20px;

  @include media('>=desktop-mini') {
    width: 120px;
    margin-bottom: 35px;
    margin-left: 40px;
  }

  &__name {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: bold;
    color: var(--ui-text-primary);

    @include media('>=desktop-mini') {
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  &__image {
    width: 100%;
    height: $product-width;
    margin-bottom: 20px;
    background-position: center;
    background-origin: border-box;
    background-size: cover;
    border: 4px solid transparent;
    border-radius: 20px;

    @include media('>=desktop-mini') {
      height: 120px;
      margin-bottom: 25px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
  }

  &__composition {
    line-height: 16px;
    cursor: pointer;

    &-name {
      width: fit-content;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      color: var(--ui-unactive-gray);
      cursor: pointer;
    }

    &-text {
      display: block;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
    }
  }

  &__price {
    margin-left: auto;
    font-size: 14px;
    font-weight: 800;
    color: var(--ui-text-primary);
  }

  &--selected {
    .product__image {
      position: relative;
      border: 4px solid var(--ui-green) !important;
      &::after {
        position: absolute;
        top: -15px;
        right: -15px;
        display: block;
        width: 32px;
        height: 32px;
        content: '';
        background-size: contain;
      }
    }
  }
}
</style>
